import { Link } from "react-router-dom";
import { useLocalization } from "../../hooks/useLocalization";
import { useLocalePath } from "../../hooks/useLocalePath";
import { RoutePageMeta } from "../../seo/RoutePageMeta";

export const NotFoundPage = () => {
  const { strings } = useLocalization();
  const { localized } = useLocalePath();
  const titleId = "not-found-title";

  return (
    <>
      <RoutePageMeta page="NOT_FOUND" internalPath="/404" />
      <section className="legal-page text-center" aria-labelledby={titleId} aria-live="polite">
        <h1 id={titleId} className="fh-title-page mx-auto">
          {strings.SEO.NOT_FOUND.TITLE}
        </h1>
        <p>{strings.SEO.NOT_FOUND.DESCRIPTION}</p>
        <Link
          to={localized("/")}
          className="mt-6 inline-block font-shentox font-semibold tracking-[0.06em] uppercase text-light-blue no-underline hover:underline hover:underline-offset-4 hover:outline hover:outline-2 hover:outline-offset-3 hover:outline-light-blue focus-visible:underline focus-visible:underline-offset-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-3 focus-visible:outline-light-blue"
        >
          {strings.SEO.NOT_FOUND.HOME_LINK}
        </Link>
      </section>
    </>
  );
};
